<template>
  <page-view :key="$route.hash" title="Logs" :overflow="false" backLink="/dashboard" backText="Back to Dashboard">
    <table-list>
      <template v-slot:table-header>
        <div class="d-f p-a-2 jc-c">
          <FormDropdown :multiple="true" placeholder="Select method" id="method" :items="methodsFilter" @input="methodsFilter = $event" tabindex="0" class="minimal" />
        </div>
      </template>
      <tr class="header">
        <th class="w-5p only-desktop">Status</th>
        <th class="w-5p only-desktop">Method</th>
        <th class="w-100p w-md-60p">Path</th>
        <th class="w-20p ta-c only-desktop">Date</th>
        <th class="w-10p extra-padding"></th>
      </tr>
      <a :href="`/developer/logs/${log.id}`" @click.prevent="$router.push(`/developer/logs/${log.id}`)" v-for="log in logs" :key="log.id">
        <td class="only-desktop"><span :class="{'ok': log.status >= 200 && log.status < 300, 'err': log.status >= 300 && log.status < 400, 'fatal': log.status >= 400}">{{ log.status }}</span></td>
        <td class="only-desktop">{{ log.method }}</td>
        <td class="ellipsis">
          <div class="blue">
            <p class="d-i">{{ log.path }}</p>
          </div>
          <div class="only-mobile d-f m-t-1">
            <span :class="{'ok': log.status >= 200 && log.status < 300, 'err': log.status >= 300 && log.status < 400, 'fatal': log.status >= 400}">{{ log.status }}</span>
            <p class="m-l-2">{{ log.method }}</p>
            <p class="ml-a">{{ log.time | formatdate('YYYY-MM-DD HH:mm:ss') }}</p>
          </div>
        </td>
        <td class="only-desktop">{{ log.time | formatdate('YYYY-MM-DD HH:mm:ss') }}</td>
        <td class="extra-padding blue"><i class="arrow mdi mdi-chevron-right"></i></td>
      </a>
    </table-list>
    <pagination class="m-t-4 m-b-2" :page="current_page" :maxPage="max_page" @page="paginate" />
  </page-view>
</template>

<script>

import TableList from '@/components/Lists/Table.vue';
import Pagination from '@/components/Lists/Pagination.vue';

export default {
  components: {
    TableList,
    Pagination,
  },
  computed: {
    methodsFilter: {
      get() {
        return [
          { string: 'GET', value: 'get', selected: this.methods.includes('get') },
          { string: 'POST', value: 'post', selected: this.methods.includes('post') },
          { string: 'DELETE', value: 'delete', selected: this.methods.includes('delete') },
          { string: 'PATCH', value: 'patch', selected: this.methods.includes('patch') },
        ];
      },
      set(method) {
        const methodIndex = this.methods.indexOf(method.value);
        if (methodIndex >= 0) {
          this.methods.splice(methodIndex, 1);
        } else {
          this.methods.push(method.value);
        }

        this.getLogs();
      },
    },
  },
  methods: {
    /**
     * Get a list of logs based on parameters
     * @returns {Void}
     */
    async getLogs() {
      const { logs, pagination } = await this.$store.dispatch('Developer/logs', {
        page: this.current_page,
        methods: this.methods,
        per_page: this.per_page,
      });

      this.logs = logs;
      this.max_page = pagination.max_page;
      this.current_page = Math.min(pagination.current_page, pagination.max_page);

      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: this.current_page,
          methods: this.methods.join(','),
        },
      });
    },
    /**
     * Paginate in logs list
     * @param {Number} page
     * @returns {Void}
     */
    paginate(page) {
      this.current_page = page;

      this.getLogs();
    },
  },
  data() {
    return {
      current_page: 1,
      max_page: 1,
      per_page: 25,
      methods: [],
      logs: [],
      mobileFilterOpen: false,
      filterOpen: false,
    };
  },
  mounted() {
    const {
      page = 1,
      methods,
    } = this.$route.query;

    if (methods) {
      methods.split(',').forEach((method) => {
        if (['get', 'post', 'delete', 'patch'].includes(method)) {
          this.methods.push(method);
        }
      });
    }

    if (this.methods.length === 0) {
      this.methods.push('post');
    }

    this.current_page = parseInt(page, 10);

    this.getLogs();
  },
};
</script>

<style lang="scss" scoped>
@import '../../variables.sass';

.ok {
  color: $successColor;
}

.err {
  color: $warningColor;
}

.fatal {
  color: $alertColor;
}
</style>
